import { useCallback } from 'react';
import { useLazyDownloadReleaseNoteAsBlobQuery } from '@/store/api';
/**
 * Platform-services lazy-query hook for downloading a release note image as a blob URL.
 *
 * @see src/store/api/cc/releaseNotesApi.ts
 */
export const useLazyDownloadReleaseNoteAsBlob = () => {
    const [trigger, { data, isLoading, isFetching, isError, error, }] = useLazyDownloadReleaseNoteAsBlobQuery();
    const triggerDownloadAsBlob = useCallback((fileName) => trigger({ fileName }).unwrap(), [trigger]);
    return {
        triggerDownloadAsBlob,
        data,
        isLoading: isLoading || isFetching,
        isError,
        error,
    };
};
